/* ==========================================================================
   Provider Pharmacy Notes Page
   Shows the pharmacy-wide note published by the provider's pharmacy
   (PORTAL-159). The note already travels on the authenticated profile, so
   there is nothing to fetch here.
   ========================================================================== */

import { NotebookText } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { ProviderPageHeader } from '@/components/layout/ProviderPageHeader'
import { ProviderTabBar } from '@/components/layout/ProviderTabBar'
import { Card } from '@/components/ui/Card'
import { MarkdownText } from '@/components/ui/MarkdownText'
import { useAuth } from '@/hooks/useAuth'

export function PharmacyNotes() {
  const { user } = useAuth()
  const notes = user?.pharmacy_notes?.trim()

  return (
    <PageContainer size="lg">
      <ProviderPageHeader />
      <ProviderTabBar />

      <Card header="Pharmacy Notes">
        {notes ? (
          <MarkdownText text={notes} />
        ) : (
          // Reachable by deep link (or a stale tab) after the pharmacy clears
          // its note — the tab itself is hidden while there is nothing to show.
          <div className="text-center py-8">
            <NotebookText
              className="h-8 w-8 mx-auto mb-3 text-[var(--color-gray-300)]"
              aria-hidden="true"
            />
            <p className="text-charcoal">
              Your pharmacy hasn&apos;t posted any notes yet.
            </p>
            <p className="text-sm text-gray-500 mt-1">
              Anything they publish will appear here.
            </p>
          </div>
        )}
      </Card>
    </PageContainer>
  )
}

export default PharmacyNotes
